import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    allGood: 'All good! Continue',
    description:
      'You can now access your Shine account from the following device:',
    new: 'New',
    title: 'Device allowed to connect',
    unknownDeviceType: 'Unknown device type',
  },
  fr: {
    allGood: 'C’est tout bon\xA0!',
    description:
      'Vous pouvez à présent accéder à votre compte Shine depuis l’appareil suivant :',
    new: 'Nouveau',
    title: 'Appareil autorisé à se connecter',
    unknownDeviceType: 'Type d’appareil inconnu',
  },
} as const);

export default locales;
